import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export const finishChatTicket = (args) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
  return axios.post('', {
    query: `
      mutation {
        finishChatTicket (
          chat_ticket_id: ` + args.id + `,
          is_finishing_without_messenger: ` + args.noMessage + `,
          reason_id: ` + args.reasonId + `,
          observation: """ ${args.observation} """,
          reason_responses_attributes: ` + JSON.stringify(args.reason_responses).replaceAll(/"([a-zA-Z-_]+)":/g, "$1:").replace(/^\{/, '').replace(/\}$/, '') + `
        ) {
          id,
          protocol,
          started_at,
          finished_at,
          is_finishing,
          unseenMsg,
          isNotResponded,
          user {
            id
          },
          instance {
            id,
            name,
            nickname
          },
          customer {
            id,
            name,
            phone_number,
            image,
            is_blacklisted,
            is_blacklisted_campaign
          },
          customerLastChat {
            id,
            type,
            sent_at,
            message,
            tag_type,
            unseen_msg,
            is_temp,
            caption,
            document_name,
            is_bot_message,
            document_mimetype
          }
        }
      }
    `
  })
}

export const finishChatTicketWithResearch = (args) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'

  return axios.post('', {
    query: `
      mutation {
        finishChatTicketWithResearch (
          chat_ticket_id: ${args.id},
          is_finishing_without_messenger: ${args.noMessage},
          is_multiple_research: ${args.isMultipleResearch},
          reason_id: ${args.reasonId},
          observation: """${args.observation}""",
          reason_responses_attributes: ` + JSON.stringify(args.reason_responses).replaceAll(/"([a-zA-Z-_]+)":/g, "$1:").replace(/^\{/, '').replace(/\}$/, '') + `
        ) {
          id,
          protocol,
          started_at,
          finished_at,
          is_finishing
        }
      }
    `
  })
}

export const finishChatTicketBatch = (operation, userIds, instanceIds, isFinishingWithoutMessenger) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
  return axios.post('', {
    query: `
      mutation {
        finishChatTicketBatch (
          operation: "` + operation + `",
          user_ids: ` + JSON.stringify(userIds) + `,
          instance_ids: ` + JSON.stringify(instanceIds) + `,
          is_finishing_without_messenger: ` + isFinishingWithoutMessenger + `
        )
      }
    `
  })
}

// usar o parâmetro 0 para department_id quando não quiser alterar o departamento
// user o parâmetro null para department_id se quiser que o atendimento seja desvinculado de seu departamento atual
export const transferChatTicket = (chatTicketId, newAttendantId, departmentId = 0) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
  return axios.post('', {
    query: `
      mutation {
        transferChatTicket (
          chat_ticket_id: ${chatTicketId},
          user_id: ${newAttendantId},
          department_id: ${departmentId}
        ) {
          id,
          user_id,
          protocol,
          started_at,
          pickable_at,
          finished_at,
          is_finishing
        }
      }
    `
  })
}

export const transferManyChatTicket = (listChatTicketId, newAttendantId, departmentId = 0) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
  return axios.post('', {
    query: `
      mutation {
        transferManyChatTicket (
          department_id: ${departmentId}
          user_id: ${newAttendantId},
          list_chat_ticket_id: ${listChatTicketId}
        )
      }
    `
  })
}

export const finishManyChatTicket = (listChatTicketId, operation = 'many_attendances') => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
  return axios.post('', {
    query: `
      mutation {
        finishManyChatTicket (
          list_chat_ticket_id: ${listChatTicketId},
          operation: "${operation}"
        )
      }
    `
  })
}

export const fetchReasonResponses = (id = null, chatTicketId) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
  return axios.post('', {
    query: `
      query {
        reasonResponses (
            id: ${id}
            chat_ticket_id: ${chatTicketId}
        ) {
            id,
            chat_ticket_id,
            reason_id,
            title,
            observation,
            reason_option {
                id,
                label,
                value,
                type,
                option_item_id
            }
        }
      }
    `
  })
}

export const checkByUser = (userId) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
  return axios.post('', {
    query: `
      query {
        checkChatTicketsByUser (
            user_id: ${userId}
        )
        {
          id,
          campaign_id,
          is_campaign,
          instance_id,
          user_id,
          finished_ticket,
          open_by_template,
          customer_id,
          last_msg,
          protocol,
          priority,
          started_at,
          finished_at,
          last_cost_created_at,
          is_finishing,
          unseenMsg,
          isNotResponded,
          inbox,
          pickableInboxChat,
          createdAt,
          curretTimestamp,
          is_research,
          bot_is_active,
          user {
            id,
            name,
            image,
            deleted_at
          },
          instance {
            id,
            name,
            nickname
          },
          campaign{
            id,
            name
          },
          inbox_department_id,
          customer {
            id,
            name,
            image,
            address,
            open_field,
            is_favorite,
            phone_number,
            is_blacklisted,
            is_blacklisted_campaign,
            document_register,
            group_of_customer {
              id,
              group_id,
              customer_id,
              name,
              color_tag
            }
          }
        }
      }
    `
  })
}